export default "__VITE_ASSET__NK0idSgN__"